// extracted by mini-css-extract-plugin
module.exports = {"presentationCTA":"styles_presentationCTA__3VMnn","presentationCTAIcon":"styles_presentationCTAIcon__3XFAO","presentationCTAText":"styles_presentationCTAText__tDTZm"};